const axios = require('axios');
const config = require('../../config/app');
const resource = `${config.remote.uri}/admin-3s`;



module.exports = {

  /**
  * Admin 3s list()
  */
 list: function (admin3Pcode = null) {
    if (admin3Pcode == null) {
      return axios.get(resource).then(response => { 
        console.log(response);
        return response });
    }
    else {
      return axios.get(resource + '/' + admin3Pcode).then(response => { return response });
    }
  },

}